import { Grid, Typography } from '@mui/material';
import { RoundProgress } from 'components/round-progress';
import CustomTooltip from 'components/custom-tooltip';
import { getRowIcon } from 'utils/helpers/fileCabinetHelpers';
import { convertBytes } from 'utils/helpers';
import { styles } from './styles';

interface IUploadGridView {
  name: string;
  mimeType: string;
  size: number;
  percent: number;
}

export const UploadGridView = ({ name, mimeType, size, percent }: IUploadGridView) => {
  const Icon = getRowIcon('file', mimeType);

  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.card}>
        <Grid sx={styles.cardHeader}>
          <Icon className={'file-icon'} />
        </Grid>
        <Grid sx={styles.cardContent}>
          <Grid sx={styles.contentContainer}>
            <CustomTooltip title={name}>
              <Typography sx={styles.folderName}>{name}</Typography>
            </CustomTooltip>
            <Grid sx={styles.details}>
              <Typography sx={styles.typo}>{convertBytes(Number(size), 2)}</Typography>
            </Grid>
          </Grid>

          <Grid sx={styles.roundProgressContainer}>
            <RoundProgress value={percent} size={40} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
